export enum DisplayLocation {
	Top = 1,
	Side = 2,
	TopAndSide = 3
}
